/**
 * Structured data, rendered into the body rather than the head.
 *
 * Google reads JSON-LD wherever it appears in the document, and the body is
 * where this app can put it: `scripts/vite-plugin-html-meta.ts` owns the head
 * and writes meta and link tags only. What makes body placement work for
 * crawlers that do not run JavaScript is `scripts/prerender.ts` — it bakes the
 * rendered `#root` into each route's HTML file, so this script tag ships as
 * static markup. A route that stops being prerendered loses its structured
 * data, which is the trade this file accepts.
 */

/** Any JSON-LD document. Shapes are schema.org's, not ours to model. */
export type JsonLdDocument = Record<string, unknown>;

/**
 * `</script>` inside a JSON string would close the tag early — the one way a
 * data-driven JSON-LD block can break the page around it.
 */
function serialize(doc: JsonLdDocument): string {
  return JSON.stringify(doc).replace(/</g, '\\u003c');
}

export function JsonLd({ doc }: { doc: JsonLdDocument }) {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: serialize(doc) }} />;
}
